import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { CalamityService } from 'app/calamity/calamity.service';
import { CalamityNoteModel } from 'app/calamity/models/calamity-note.model';
import { NoteTypeService } from 'app/intake/note/note-type.service';
import { CONTACTS } from 'app/_constants/contacts';
import { UserProfile } from 'app/_models';
import { AuthenticationService } from 'app/_services';
import { Subject } from 'rxjs';
import { find, takeUntil } from 'rxjs/operators';
import { CalamityNoteService } from '../calamity-note.service';

@Component({
  selector: 'app-calamity-note-details',
  templateUrl: './calamity-note-details.component.html',
  styleUrls: ['./calamity-note-details.component.scss']
})
export class CalamityNoteDetailsComponent extends DialogContentBase implements OnInit {
  private destroySubject$: Subject<void> = new Subject();
  public calamityNoteForm: FormGroup;
  @Input() editMode = true;
  public noteTypeList = [];
  public profile: UserProfile = new UserProfile();
  public contactWithList = [];
  public selectedNoteType: string;
  public calamityNote : CalamityNoteModel = new CalamityNoteModel();
  public operationType : any = null;
  public calamityId : string = null;
  public addAction ;

  constructor(dialog: DialogRef,
    private noteTypeService: NoteTypeService,
    private authenticationService: AuthenticationService,
    private translate: TranslateService,
    private calamityService : CalamityService,
    private calamityNoteService : CalamityNoteService
    ) { super(dialog) }

  ngOnInit() {
    this.initForm();
    this.getCalamityId();
    this.getNoteTypeListByRole();
    this.initContactList();
  }

  initForm() {
    this.calamityNoteForm = new FormGroup({
      noteTypes: new FormControl({ value: "", disabled: !this.editMode }, [
        Validators.required,
      ]),
      contactWith: new FormControl({ value: "", disabled: !this.editMode }),
      medicalInformation: new FormControl({
        value: "",
        disabled: !this.editMode,
      }),
      conversationNote: new FormControl({
        value: "",
        disabled: !this.editMode,
      }),
      agreements: new FormControl({ value: "", disabled: !this.editMode }),
      guarantees: new FormControl({ value: "", disabled: !this.editMode }),
      caseDescription: new FormControl({ value: "", disabled: !this.editMode }),
      coverageStatement: new FormControl({
        value: "",
        disabled: !this.editMode,
      }),
      plan: new FormControl({ value: "", disabled: !this.editMode }),
      repatriationDecision: new FormControl({
        value: "",
        disabled: !this.editMode,
      }),
      repatriationJudgement: new FormControl({
        value: "",
        disabled: !this.editMode,
      }),
      managedBy: new FormControl({ value: "", disabled: !this.editMode }),
      addedDateTime: new FormControl({ value: "", disabled: !this.editMode }),
      updatedDateTime: new FormControl({ value: "", disabled: !this.editMode }),
    });
  }

  initContactList() {
    CONTACTS.forEach((element) => {
      this.contactWithList.push(this.translate.instant(element.KEY));
    });
  }

  getCalamityId(){
    this.calamityService.calId$.pipe(takeUntil(this.destroySubject$))
    .subscribe(res=> {
       this.calamityId=res;
    });
  }

  getNoteTypeListByRole() {
    this.noteTypeService
      .GetNoteTypeListByRole(this.getRoles())
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data: any) => {
        this.noteTypeList = data;
        if (data.length > 0) {
          let calamityType = data.find(c=> c.notCode =="OPS");
          this.calamityNoteForm.controls["noteTypes"].setValue(calamityType);
          this.selectedNoteType = calamityType.notShortName;
          this.operationType = calamityType;
          this.calamityNoteForm.controls["noteTypes"].updateValueAndValidity();
          this.calamityNoteForm.controls["noteTypes"].disable();
        }
      });
  }
  
  getRoles() {
    let roles = this.authenticationService.getLocalStorageRoles();
    this.profile.roles = [...new Set(roles.map((item) => item.authorizationGroupRoleId)),
    ];
    if(typeof this.profile.roles === 'string') 
    {
      this.profile.roles = [this.profile.roles];
    }
    return this.profile.roles;
  }

  addCalamityNote(calamityNoteFormValue) {
    this.calamityNote.clnCalamityId = this.calamityId;
    this.calamityNote.clnCreatedBy = this.profile.fullName;
    this.calamityNote.clnNoteTypeId = this.operationType.notId;
    let clnFreeText = {
      isDependent: false,
      agreements: calamityNoteFormValue.agreements,
      guarantees: calamityNoteFormValue.guarantees,
      caseDescription: calamityNoteFormValue.caseDescription,
      contactWith: calamityNoteFormValue.contactWith,
      conversationNote: calamityNoteFormValue.conversationNote,
      coverageStatement: calamityNoteFormValue.coverageStatement,
      medicalInformation: calamityNoteFormValue.medicalInformation,
      plan: calamityNoteFormValue.plan,
      repatriationDecision: calamityNoteFormValue.repatriationDecision,
      repatriationJudgement: calamityNoteFormValue.repatriationJudgement
    };
    this.calamityNote.clnFreeText = JSON.stringify(clnFreeText);
    if(!this.addAction){
      this.calamityNoteService
      .save(this.calamityNote)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data: any) => {
        this.dialog.close(this.calamityNote);
      });

    } else {
      this.dialog.close(this.calamityNote);
    }
      
     
  }
  cancel() {
    this.dialog.close();
  }

  ngOnDestroy() {
    this.destroySubject$.unsubscribe();
  }
}